import React from 'react';
import styles from '../../styles/components/page/PageHeader.module.css';
import backIcon from '../../assets/arrow_left_dark.svg';

export interface BackAction {
  text: string;
  onCompletion: () => void;
}

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  subtitleInfo?: JSX.Element;
  backAction?: BackAction;
  type?: 'primary' | 'secondary';
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  subtitleInfo,
  backAction,
  type = 'primary',
}) => {
  const primary = type !== 'secondary';
  return (
    <div
      className={[
        styles.container,
        primary ? styles.containerPrimary : styles.containerSecondary,
      ].join(' ')}
    >
      <div className={styles.content}>
        {backAction && (
          <div
            className={[
              styles.backActionContainer,
              primary
                ? styles.backActionContainerPrimary
                : styles.backActionContainerSecondary,
            ].join(' ')}
            onClick={backAction.onCompletion}
          >
            <img src={backIcon} alt="back" />
            <span className={styles.backActionText}>{backAction.text}</span>
          </div>
        )}
        <h1
          className={[
            styles.title,
            primary ? styles.titlePrimary : styles.titleSecondary,
          ].join(' ')}
        >
          {title}
        </h1>
        {subtitle && (
          <h2
            className={[
              styles.subtitle,
              primary ? styles.subtitlePrimary : styles.subtitleSecondary,
            ].join(' ')}
          >
            {subtitle}
            {subtitleInfo && (
              <div className={styles.subtitleInfo}>{subtitleInfo}</div>
            )}
          </h2>
        )}
      </div>
    </div>
  );
};
export default PageHeader;
